import script from "./MobileReportInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReportInfo.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=7b8bb4fd&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8bb4fd"]])

export default __exports__